import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import httpApiCall from "../service/api.service";
import { formatCurrencyUSA } from "../utils/CurrencyFormatter";
import { formatDate, formatDate2 } from "../utils/DateFormat";
import * as XLSX from "xlsx";
import { CSVLink } from "react-csv";


const Report = () => {
  const dataArray = [
    ["Sr.	", "Tier","Business Name", "Business Code","Contract Code","Payment Type", "Transaction Date", "Commission Amount"]
  ];
  const csvLinkRef = useRef<any>(null);
  const [shimmer, setShimmer] = useState(false);
  const [partnerData, setPartnerData] = useState<any>([]); 
  const [commisionData, setCommisionData] = useState<any>([]); 
  const [currentDate, setCurrentDate] = useState(new Date());
  const [startOfMonth, setStartOfMonth] = useState(new Date("2017-01-01"));

  const [searchParams] = useSearchParams();
  const accessToken: any = searchParams.get("access_token");
  const downloadType: any = searchParams.get("type");
  const startDate: any = searchParams.get("startDate");
  const endDate: any = searchParams.get("endDate");
  const language: any = searchParams.get("lang");

  const columns = [
    { title: "S.NO", dataKey: "sno" },
    { title: "Tier", dataKey: "tier" },
    { title: "Business Name", dataKey: "businessName" },
    { title: "Business Code", dataKey: "businessCode" },
    { title: "Contract Code", dataKey: "contractCode" },
    { title: "Payment Type", dataKey: "paymentType" },
    { title: "Transaction Date", dataKey: "transactionDate" },
    { title: "Commission Amount", dataKey: "amount" },
  ];

  useEffect(() => {
    getPartnerData();

  }, []);

  const getPartnerData = async () => {
    const body = {
      access_token: accessToken,
    };

    await httpApiCall({ api: "access_token_login", type: "post", body })
      .then((res: any) => {
        setPartnerData(res.partner_profile);
        if(res.partner_profile){
          getListCommissions(res.partner_profile);

        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const getListCommissions = async (profiledata :any) => {
    setShimmer(true);

    const body = {
      access_token: accessToken,
      start_date: startDate,
      end_date: endDate,
      limit: 0,
      offset: 0,
      language_preffered:language

    };

    await httpApiCall({
      api: "partner_commision_listing",
      type: "POST",
      body,
    }).then(async (data) => {
      console.log(data);
      
      
      if(downloadType && downloadType == 1){
        downloadPDF(data , profiledata);
  
      }
      else if(downloadType && downloadType == 2){
        exportXlsx(data);
  
      }
      else{
        setCommisionData(data)
        setTimeout(() => {
          if (csvLinkRef.current) {
            csvLinkRef.current.link.click();
          }
        }, 500);      
      }

      setShimmer(false);
    });
  };


  const exportXlsx = (data: any) => {
    const dataArray = [
      ["Sr.	", "Tier","Business Name", "Business Code","Contract Code","Payment Type", "Transaction Date", "Commission Amount"],
    ];
    data &&
      data?.payments?.forEach((item: any, i: any) => {
        const row = [
          i + 1,
          item.partner_level,
          item.doctor_name,
          item.doctor_referral_code,
          item.contract_code,
          item.payment_type,
          formatDate(item.created),
          item.pay_to_partner
        ];
        dataArray.push(row);
      });
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(dataArray);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "CredeePayoutReport" + ".xlsx");
    return;
  };
  const downloadPDF = (data: any, partnerData:any) => {
    const doc = new jsPDF();
    let amount: any = 0;
  
    if (data?.payments) {
      data.payments.forEach((item: any) => {
        amount += item.amount;
      });
    }
  
    amount = formatCurrencyUSA(amount);
  
    const rows = data?.payments ? data.payments.map((row: any, index: number) => [
      index + 1,
      'Tier ' + row.partner_level,
      row.doctor_name,
      row.doctor_referral_code,
      row.contract_code,
      row.payment_type,
      formatDate(row.created),
      row.pay_to_partner
    ]) : [];
  
    doc.text('Payout statement', 10, 10);
    doc.line(75, 22, 75, 30, 'F');
    doc.line(165, 22, 165, 30, 'F');
  
    doc.setFontSize(8);
    doc.text('Name', 20, 25);
    doc.text('Email Address', 80, 25);
    doc.text('Phone', 170, 25);
  
    if (partnerData?.length) {
      const partner = partnerData[0];
      doc.setFontSize(10);
      doc.text(String(partner.partner_name || ''), 20, 30);
      doc.text(String(partner.partner_email || ''), 80, 30);
      doc.text(`${partner.partner_mobile_country_code || ''}-${partner.partner_mobile || ''}`, 170, 30);
    }
  
    doc.setFontSize(8);
    doc.text('Total payment', 20, 45);
    doc.setFontSize(10);
    doc.text(amount, 20, 50);
  
    autoTable(doc, {
      startY: 60,
      headStyles: { fillColor: [1, 61, 80] },
      head: [columns.map(item => item.title)],
      body: rows,
    });
  
    doc.save("CredeePayoutReport.pdf");
  };
  

  return (
    <div>
      <h1>DOWNLOADING.......</h1>
      <div className="csvLink">
          {commisionData && <CSVLink
            data={dataArray}
            headers={ commisionData &&commisionData?.payments?.map((item: any, i: any) => {
              const row = [
                i + 1,
                item.partner_level,
                item.doctor_name,
                item.doctor_referral_code,
                item.contract_code,
                item.payment_type,
                formatDate2(item.created),
                item.pay_to_partner
              ];
              dataArray.push(row);
            })}
            filename={"CredeePayoutReport.csv"}
            target={"_blank"}
            type="button"
            ref={csvLinkRef}
          ></CSVLink>}
        </div>
    </div>
  );
};

export default Report;
